import {bpInfo} from '../bpInfo';

const somethingToAdd = '_lab';
export const environment = {
    production: true,
    description: somethingToAdd,
    fidjKey: 'fidj-c7da8742d81613d8',
    // TODO  serverUrl: 'http://localhost:3004/v3',
    serverUrl: 'https://api.lab.radartorain.com/v3',
    version: bpInfo.version + somethingToAdd,
};
